// src/index.ts
import findConditionalComments from "find-conditional-comments";
import MagicString from "magic-string";
var opener = `<!--__PROCESS_CONDITIONAL_COMMENTS`;
var closer = `__PROCESS_CONDITIONAL_COMMENTS-->`;
function preprocess(source) {
  const magicSource = new MagicString(source);
  const comments = findConditionalComments(source);
  for (let comment of comments) {
    if (!comment.isComment) {
      continue;
    }
    if (comment.bubble) {
      continue;
    }
    const contentStartIndex = comment.range[0] + comment.open.length;
    const contentEndIndex = comment.range[1] - comment.close.length;
    magicSource.prependLeft(contentStartIndex, closer);
    magicSource.appendRight(contentEndIndex, opener);
  }
  return magicSource.toString();
}
function postprocess(source) {
  return source.replace(new RegExp(`(${opener}|${closer})`, "g"), "");
}
export {
  postprocess,
  preprocess
};
